import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormLabel, FormControl, FormControlLabel } from 'material-ui/Form';
import { InputAdornment } from 'material-ui/Input';

class StepInfo extends Component {
    constructor(props) {
        super(props);
        this.state = { event: this.props.event, disablenextbtn: true };
        this.handleInputChange = this.handleInputChange.bind(this);
        //this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        //this.validatorListener = this.validatorListener.bind(this);
    }

    handleInputChange(event) {
        let eventState = Object.assign({}, this.state.event, { [event.target.name]: event.target.value });
        this.setState({ event: eventState });
        return this.props.returnfnc(eventState);
    }

    handleSubmit() { }

    render() {
        const { event } = this.state;
        return (
            <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
                onError={errors => console.log(errors)}
            >
                <div>
                    <TextValidator
                        label="Titolo"
                        onChange={this.handleInputChange}
                        name="title"
                        value={event.title}
                        validators={['required']}
                        errorMessages={['il titolo dell\'evento è obbligatorio']}
                    />
                    <TextField
                        id="descrizione"
                        label="Descrizione"
                        name="description"
                        multiline
                        value={event.description}
                        onChange={this.handleInputChange}
                        rows="4"
                        margin="normal"
                    />
                    <TextField
                        id="fburl"
                        label="Url evento su facebook"
                        name="fb_link"
                        value={event.fb_link}
                        onChange={this.handleInputChange}
                        margin="normal"
                    />
                    <TextField
                        id="externalurl"
                        label="Url sito esterno"
                        name="external_link"
                        value={event.external_link}
                        onChange={this.handleInputChange}
                        margin="normal"
                    />
                </div>
                <div>
                    <FormControl component="fieldset" required>
                        <FormLabel component="legend">Gender</FormLabel>
                        <RadioGroup
                            aria-label="gender"
                            name="pricetype"
                            value={event.pricetype}
                            onChange={this.handleInputChange}
                        >
                            <FormControlLabel value="0" control={<Radio />} label="Gratuito" />
                            <FormControlLabel value="1" control={<Radio />} label="Offerta libera" />
                            <FormControlLabel value="2" control={<Radio />} label="A pagamento" />
                            {
                                event.pricetype === "2" &&
                                <TextField
                                    label="Costo ingresso"
                                    name="price"
                                    id="price"
                                    value={event.price}
                                    onChange={this.handleInputChange}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                    }}
                                />
                            }
                        </RadioGroup>
                    </FormControl>
                </div>
            </ValidatorForm>
        );
    }
}

StepInfo.propTypes = {
    event: PropTypes.object.isRequired,
    returnfnc: PropTypes.func.isRequired
};

export default StepInfo;


// WEBPACK FOOTER //
// ./src/components/eventstepper/StepInfo.js